"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_broadband__or__wifi__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "c4dba355-1620-41ae-a6f4-efb655380407",
    "data-name": "Broadband_ic_hi 2",
    viewBox: "0 0 192 192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 160,
    height: 160,
    rx: 80,
    ry: 80,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fa4a42bd-b59d-43ff-8dce-28a6df31c2d2",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "042280e8-da1c-4a0b-be37-c1481f633cb8",
    "data-name": "<Pfad>",
    cx: 96,
    cy: 118,
    r: 8,
    fill: "#4a4d4e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "d969ffd8-428f-47e6-88e9-3e3e607e29f4",
    "data-name": "<Pfad>",
    d: "M54.17,79.37a59.13,59.13,0,0,1,83.66,0",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "370c27c9-583f-45c0-a022-02c3e872fbb5",
    "data-name": "<Pfad>",
    d: "M66.28,90a42.25,42.25,0,0,1,59.77,0",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "7b9c047b-d52e-4d6e-9d4e-dc33ed15caf6",
    "data-name": "<Pfad>",
    d: "M78.72,99.18a24.58,24.58,0,0,1,34.73,0",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174h0A80.23,80.23,0,0,1,16,95c0,.33,0,.66,0,1h0a80.24,80.24,0,0,0,80,80h0a80.24,80.24,0,0,0,80-80h0c0-.34,0-.67,0-1A80.23,80.23,0,0,1,96,174Z",
    opacity: 0.06
  }))), /*#__PURE__*/React.createElement("title", null, "broadband-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "206d6fd2-6587-4f3a-a3cf-672bd6fc6c2c",
    "data-name": "Broadband_ic"
  }, /*#__PURE__*/React.createElement("use", {
    id: "9b9d247a-eb5d-4685-b1da-e86cab7165b6",
    "data-name": "Broadband_ic_hi 2",
    width: 192,
    height: 192,
    transform: "translate(0 0)",
    xlinkHref: "#c4dba355-1620-41ae-a6f4-efb655380407"
  })));
}

var _default = ic_broadband__or__wifi__dark;
exports.default = _default;